import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useToolsRoutesConditions } from '../../../../Tools/ToolsRoutes'
import { ToolsIcon } from '../../../../icons/ToolsIcon'
import { TickmillProductType } from '../../../../model/TickmillProductType'
import { MenuSection } from '../useMenuSections'

export const useToolsMenu = (): MenuSection => {
  const { t } = useTranslation()
  const { isToolsVisible } = useToolsRoutesConditions()

  return useMemo(
    () => ({
      id: 'tools',
      label: t('Tabs.Tools'),
      icon: ToolsIcon,
      condition: isToolsVisible,
      products: [TickmillProductType.CFD, TickmillProductType.ETD],
      children: [
        {
          id: 'platforms',
          label: t('Platforms'),
          path: '/dashboard/tools/platforms',
          products: [TickmillProductType.CFD],
        },
        {
          id: 'earnings-calendar',
          label: t('Earnings Calendar'),
          path: '/dashboard/tools/earnings-calendar',
          products: [TickmillProductType.CFD],
        },
        {
          id: 'economic-calendar',
          label: t('Economic Calendar'),
          path: '/dashboard/tools/economic-calendar',
          products: [TickmillProductType.CFD],
        },
        {
          id: 'research-terminal',
          label: t('Research Terminal'),
          path: '/dashboard/tools/research-terminal',
          products: [TickmillProductType.CFD],
        },
        {
          id: 'platform-vendors',
          label: t('Platform Vendors.title'),
          path: '/dashboard/tools/platform-vendors',
          products: [TickmillProductType.ETD],
        },
        {
          id: 'market-data-vendors',
          label: t('Market Data.Market Data Vendors'),
          path: '/dashboard/tools/market-data-vendors',
          products: [TickmillProductType.ETD],
        },
      ],
    }),
    [t, isToolsVisible]
  )
}
